export default __webpack_public_path__ + "static/media/subcategory_car_5.57cdb467.png";